import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsultationsService } from '../../../../core/services/consultation/consultations.service';
import { TranslateService } from '@ngx-translate/core';
import { GeneratePdfService } from '../../../../core/services/generate-pdf.service';
@Component({
  selector: 'app-ai-report',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ai-report.component.html',
  styleUrl: './ai-report.component.scss',
})
export class AiReportComponent {
  @Input() consultationId: string = '';
  aiReportError: string = '';

  constructor(
    private consultationsService: ConsultationsService,
    private translateService: TranslateService,
    private generatePdfService: GeneratePdfService
  ) {}

  ngOnInit() {
    if (this.consultationId) {
      this.getAIReport(this.consultationId);
    }
  }

  getAIReport(id: string) {
    this.consultationsService
      .patientRecordCaseReportsByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          if (res?.patientRapport === '') {
            this.aiReportError = this.translateService.instant(
              'noAIReportToBeDisplayed'
            );
          } else {
            this.aiReportError = '';
            this.generatePdfService.displayPdf(res.patientRapport, 'aiReport');
          }
        },
        error: () => {
          this.aiReportError = this.translateService.instant(
            'noAIReportToBeDisplayed'
          );
        },
      });
  }
}
